'use client';

import { c as _c } from "react/compiler-runtime";
import { ElementType, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { getArticlePath } from '@sola/contentful-model/lib/article.ts';
import { ArticleTypesEnum } from '@sola/contentful-model/lib/taxonomy-values.ts';
import { slugify, trailingSlash } from '@sola/utils/string.ts';
export const ArticleTabsEnum = z.enum(['all', 'topic', 'theme', 'country', 'search']);
export type ArticleTabsEnum = z.infer<typeof ArticleTabsEnum>;
export const ArticleTermListProps = z.object({
  terms: z.array(z.object({
    path: z.string(),
    name: z.string()
  })),
  group: ArticleTabsEnum // todo: don't do this in zod 4
});
export type ArticleTermListProps = z.infer<typeof ArticleTermListProps>;
type FacetType = ({
  field: string;
  values: {
    key: string;
    count: number;
  }[];
} | undefined)[];
type TaxonomyFacets = {
  topic?: FacetType;
  theme?: FacetType;
  country?: FacetType;
};
type ArticleTermListTypes = {
  seoLevel: number;
  tabGroup: ArticleTabsEnum;
  articleType: ArticleTypesEnum;
  facets: TaxonomyFacets;
};
export const ArticleTermList: React.FC<ArticleTermListTypes> = t0 => {
  const $ = _c(8);
  const {
    seoLevel: t1,
    articleType,
    facets
  } = t0;
  const seoLevel = t1 === undefined ? 3 : t1;
  const pathname = getArticlePath("tag", articleType);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["geo", "skippy"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const parsed = [];
  Object.keys(facets).forEach(key => {
    const taxonomyKey = key as keyof typeof facets;
    if (facets[taxonomyKey]) {
      facets[taxonomyKey][0]?.values.forEach(term => {
        let termName = "";
        if (key === "country") {
          const country = term.key.toUpperCase();
          termName = t(`geo:countries.${country}.nameS`);
        }
        if (key !== "country") {
          termName = key === "theme" ? t(`articles:taxonomy.articleThemes.${term.key}.name`, t("articles:taxonomy.all")) : t(`articles:taxonomy.articleTopics.${term.key}.name`, t("articles:taxonomy.all"));
        }
        parsed.push({
          path: `${trailingSlash(pathname)}${slugify(termName)}/`,
          name: termName
        });
      });
    }
  });
  const terms = parsed?.sort(_temp);
  const Comp = `h${seoLevel}` as ElementType;
  let t3;
  if ($[1] !== Comp || $[2] !== terms) {
    let t4;
    if ($[4] !== Comp) {
      t4 = term_0 => <li className="ArticleTermList__item" key={term_0.path}><LinkStyle noUnderline={true} size="lg" purpose="neutral" noPadding={true}><Link href={term_0.path} title={term_0.name}><Comp className="label-potent body-md">{term_0.name}</Comp></Link></LinkStyle></li>;
      $[4] = Comp;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = terms.map(t4);
    $[1] = Comp;
    $[2] = terms;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <ul className="ArticleTermList m-none p-none gap-comfy-lg grid grid-cols-1 md:grid-cols-3 md:grid-flow-col">{t3}</ul>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(a, b) {
  return a.name.localeCompare(b.name);
}